<template>
  <div style="height: 100%;">
    <top-bar></top-bar>
    <app-main v-if="showPageHeader" style="height: calc(100% - 118px); overflow-y: auto; box-sizing: border-box"></app-main>
    <app-main v-else style="height: calc(100% - 68px); overflow-y: auto; box-sizing: content-box"></app-main>
  </div>
</template>

<script>
  import TopBar from '@/layout/TopBar'
  import AppMain from '@/layout/AppMain'

  export default {
    name: 'Layout',
    components: {
      AppMain,
      TopBar
    },
    computed: {
      showPageHeader () {
        if (!this.$route.meta) return true
        return !this.$route.meta.hidePageHeader
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
